import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsWorkOrdersLaborList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsWorkOrdersLaborList/ReportsWorkOrdersLaborList/ReportsWorkOrdersLaborList"
    )
);
export const ReportsWorkOrdersLaborListPage = () => {
  return (
    <Layout>
      <ReportsWorkOrdersLaborList />
    </Layout>
  );
};
